<template>
  <NavbarApp/>
  <div class="data-privacy-container">
    <h2 class="data-privacy-title">
      {{ $t('dataPrivacyPage.title') }}
    </h2>
    <ul class="data-privacy-list">
      <li id="section1">
        <h3 class="data-privacy-subtitle">
          {{ $t('dataPrivacyPage.section1.title') }}
        </h3>
        <p >{{ $t('dataPrivacyPage.section1.paragraph1')}}@{{ $t('dataPrivacyPage.section1.paragraph2')}}</p>
      </li>
       <li id="section2">
      <h3 class="data-privacy-subtitle">
        {{ $t('dataPrivacyPage.section2.title') }}
      </h3>
      <p>
        {{ $t('dataPrivacyPage.section2.paragraph') }}
      </p>
      <ul class="data-privacy-sublist">
        <li v-html="$t('dataPrivacyPage.section2.cookie')"></li>
        <li v-html="$t('dataPrivacyPage.section2.device')"></li>
        <li v-html="$t('dataPrivacyPage.section2.ipAddress')"></li>
        <li v-html="$t('dataPrivacyPage.section2.personalData')"></li>
      </ul>
    </li>

    <li id="section3">
      <h3 class="data-privacy-subtitle">
        {{ $t('dataPrivacyPage.section3.title') }}
      </h3>
      <p>
        {{ $t('dataPrivacyPage.section3.paragraph') }}
      </p>
      <ul class="data-privacy-sublist">
        <li>
          <h4 v-html="$t('dataPrivacyPage.section3.onlineData.title')"></h4>
          <p v-html="$t('dataPrivacyPage.section3.onlineData.paragraph1')"></p>
          <p v-html="$t('dataPrivacyPage.section3.onlineData.purpose')"></p>
          <p v-html="$t('dataPrivacyPage.section3.onlineData.legalBasis')"></p>
        </li>
        <li>
          <h4 v-html="$t('dataPrivacyPage.section3.cookiesData.title')"></h4>
          <p v-html="$t('dataPrivacyPage.section3.cookiesData.paragraph1')"></p>
          <p v-html="$t('dataPrivacyPage.section3.cookiesData.legalBasis')"></p>
          <p v-html="$t('dataPrivacyPage.section3.cookiesData.note')"></p>
        </li>
      </ul>
    </li>

    <li id="section4">
      <h3 class="data-privacy-subtitle">
        {{ $t('dataPrivacyPage.section4.title') }}
      </h3>
      <p>
        {{ $t('dataPrivacyPage.section4.paragraph') }}
      </p>
      <ul>
        <li>{{ $t('dataPrivacyPage.section4.list.item1') }}</li>
        <li>{{ $t('dataPrivacyPage.section4.list.item2') }}</li>
        <li>{{ $t('dataPrivacyPage.section4.list.item3') }}</li>
        <li>{{ $t('dataPrivacyPage.section4.list.item4') }}</li>
        <li>{{ $t('dataPrivacyPage.section4.list.item5') }}</li>
        <li>{{ $t('dataPrivacyPage.section4.list.item6') }}</li>
        <li>{{ $t('dataPrivacyPage.section4.list.item7') }}</li>
        <li>{{ $t('dataPrivacyPage.section4.list.item8') }}</li>
        <li>{{ $t('dataPrivacyPage.section4.list.item9') }}</li>
      </ul>
      <p>
        {{ $t('dataPrivacyPage.section4.contactInfo') }}@{{ $t('dataPrivacyPage.section4.contactInfo2') }}
      </p>
      <p>
        {{ $t('dataPrivacyPage.section4.emailContact') }}office@islaw.ro.
      </p>
      <p>
        {{ $t('dataPrivacyPage.section4.identityVerification') }}
      </p>
    </li>

    <li id="section5">
      <h3 class="data-privacy-subtitle">
        {{ $t('dataPrivacyPage.section5.title') }}
      </h3>
      <p>
        {{ $t('dataPrivacyPage.section5.paragraph') }}
      </p>
    </li>

    <li id="section6">
      <h3 class="data-privacy-subtitle">
        {{ $t('dataPrivacyPage.section6.title') }}
      </h3>
      <p>
        {{ $t('dataPrivacyPage.section6.paragraph1') }}
      </p>
      <p>
        {{ $t('dataPrivacyPage.section6.paragraph2') }}
      </p>
      <p>
        {{ $t('dataPrivacyPage.section6.paragraph3') }}
      </p>
    </li>

    <li id="section7">
      <h3 class="data-privacy-subtitle">
        {{ $t('dataPrivacyPage.section7.title') }}
      </h3>
      <p>
        {{ $t('dataPrivacyPage.section7.paragraph') }}
      </p>
    </li>

    <li id="section8">
      <h3 class="data-privacy-subtitle">
        {{ $t('dataPrivacyPage.section8.title') }}
      </h3>
      <p>
        {{ $t('dataPrivacyPage.section8.paragraph1') }}
      </p>
      <ul>
        <li>{{ $t('dataPrivacyPage.section8.list.item1') }}</li>
        <li>{{ $t('dataPrivacyPage.section8.list.item2') }}</li>
        <li>{{ $t('dataPrivacyPage.section8.list.item3') }}</li>
        <li>{{ $t('dataPrivacyPage.section8.list.item4') }}</li>
        <li>{{ $t('dataPrivacyPage.section8.list.item5') }}</li>
        <li>{{ $t('dataPrivacyPage.section8.list.item6') }}</li>
      </ul>
      <p>
        {{ $t('dataPrivacyPage.section8.paragraph2') }}
      </p>
    </li>

    <li id="section9">
      <h3 class="data-privacy-subtitle">
        {{ $t('dataPrivacyPage.section9.title') }}
      </h3>
      <p>
        {{ $t('dataPrivacyPage.section9.paragraph') }}
      </p>
    </li>

    <li id="section10">
      <h3 class="data-privacy-subtitle">
        {{ $t('dataPrivacyPage.section10.title') }}
      </h3>
      <p>
        {{ $t('dataPrivacyPage.section10.paragraph1') }}
      </p>
      <p>
        {{ $t('dataPrivacyPage.section10.paragraph2') }}
      </p>
    </li>
    </ul>
  </div>
  <Section4/>
</template>


<script>
import NavbarApp from '../components/HomePage/navbar-law.vue'
import Section4 from '../components/HomePage/section-4.vue'

export default {
  name: 'DataPrivacy',
  components: {
    NavbarApp,
    Section4,
  }
  
};
</script>



<style scoped>

:root {
  --primary-color: #333;
  --secondary-color: #666;
  --background-color: #f9f9f9;
  --border-color: #ddd;
  --font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

body {
  margin: 0;
  padding: 0;
  font-family: var(--font-family);
  background-color: var(--background-color);
  color: var(--primary-color);
  line-height: 1.6;
}

.data-privacy-container {
  text-align: justify;
  text-justify: inter-word;
  max-width: 900px;
  margin: 40px auto;
  padding: 20px 20px 40px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);

}

/* --- Headings --- */
.data-privacy-title {
  
  font-size: 2.5rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 2rem;
  border-bottom: 2px solid var(--border-color);
  padding-bottom: 1rem;
}

.data-privacy-subtitle {
  font-size: 1.5rem;
  font-weight: 500;
  color: var(--primary-color);
  margin-top: 2rem;
  margin-bottom: 1rem;
}

/* --- Paragraphs and Lists --- */
p {
  margin-bottom: 1.5rem;
}

.data-privacy-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.data-privacy-list > li {
  margin-bottom: 2.5rem;
}

.data-privacy-sublist {
  list-style-type: disc;
  padding-left: 20px;
}

.data-privacy-sublist li {
  margin-bottom: 1rem;
}

/* --- Responsive adjustments for smaller screens --- */
@media (max-width: 768px) {
  .data-privacy-container {
    margin: 20px;
    padding: 15px;
  }

  .data-privacy-title {
    font-size: 2rem;
    margin-bottom: 1.5rem;
  }

  .data-privacy-subtitle {
    font-size: 1.3rem;
  }
}
</style>